import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./globals.css";
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
const InvoicePage = lazy(() => import("./pages/Invoice/InvoicePage"));
const PaymentPage = lazy(() => import("./pages/Invoice/PaymentPage"));

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/invoice/:token" element={<InvoicePage />} />
          <Route path="/pay/:token" element={<PaymentPage />} />
          <Route path="*" element={<App />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
